import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { NG_ICON_DIRECTIVES, provideIcons } from '@ng-icons/core';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { UserCardConfig } from 'src/app/types/UserCardConfig';
import Swal from 'sweetalert2';
import { ApiService } from './../../services/api.service';
import { UtilService } from './../../services/util.service';
import { WidgetService } from './../../services/widget.service';
import { CommonProfileInfoComponent } from '../common-profile-info/common-profile-info.component';
import { UserCardComponent } from '../../components/cards/user-card/user-card.component';
import { WIDGET_DATA } from 'src/app/components/suggestions/suggestions.component';
import { APP_ICONS } from '../../icons/icon-provider';

@Component({
  selector: 'app-people-inyour-network',
  standalone: true,
  imports: [
    CommonModule,
    InfiniteScrollModule,
    CommonProfileInfoComponent,
    UserCardComponent,
    NG_ICON_DIRECTIVES
  ],
  providers: [provideIcons(APP_ICONS)],
  templateUrl: './people-inyour-network.component.html',
  styleUrls: ['./people-inyour-network.component.scss']
})
export class PeopleInyourNetworkComponent implements OnInit, OnChanges {

  headerTitle: string = 'People in your Network';
  peopelData: Array<any> = [];
  @Input() inputData: string;
  @Input() widgetDesc: string;
  @Input() page: string;
  @Input() master: string;
  @Input() suggestion: any;
  title = 'People most active in your Network';

  viewType: string = "MIN";
  @Input() maxMin: any = {};
  pathdata: any;
  commonDatahide: any = {}
  // Support both @Output EventEmitter and @Input callback function for NgComponentOutlet
  @Output() commonFunction: any = new EventEmitter<string>();
  userCardConfig: UserCardConfig[] = []

  constructor(
    private auth: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private util: UtilService,
    private widget: WidgetService,
    @Optional() @Inject(WIDGET_DATA) private widgetData: any
  ) {
    console.log('PeopleInyourNetworkComponent: Constructor called, widgetData:', widgetData);
    // Apply injected widget data (Angular 15 NgComponentOutlet pattern)
    if (this.widgetData) {
      this.inputData = this.widgetData.inputData;
      this.page = this.widgetData.page;
      this.widgetDesc = this.widgetData.widgetDesc;
      this.suggestion = this.widgetData.suggestion;
      if (this.widgetData.commonFunction) {
        this.commonFunction = this.widgetData.commonFunction;
      }
      console.log('PeopleInyourNetworkComponent: Applied widgetData, inputData =', this.inputData);
    }
  }

  private apiCalled = false; // Prevent duplicate API calls

  ngOnChanges(changes: SimpleChanges): void {
    // Handle widgetDesc changes for NgComponentOutlet compatibility
    if (changes.widgetDesc && changes.widgetDesc.currentValue) {
      this.headerTitle = changes.widgetDesc.currentValue;
    }

    // Handle inputData changes - this is critical for NgComponentOutlet
    if (changes.inputData && changes.inputData.currentValue) {
      this.getNetworkSuggestion();
    }
  }

  ngOnInit() {

    if (this.maxMin.viewType != undefined) {
      this.viewType = "MAX";
      this.inputData = this.maxMin.master;
    }
    // Only set headerTitle if widgetDesc is provided (ngOnChanges handles dynamic updates)
    if (this.widgetDesc) {
      this.headerTitle = this.widgetDesc;
    }

    this.route.queryParams.subscribe((res) => {
      this.pathdata = res;
      if (res.master != "NETWORK" && res.master != "TEAM" && res.menu != null && res.menu != undefined) {
        this.headerTitle = res.menu;
      }
      // Load data after pathdata is populated (needed for businessId/communityId from URL)
      this.getNetworkSuggestion();
    })

  }

  modelopen(data) {
    let dataPass: any = {};
    dataPass.data = data;
    dataPass.master = this.page;
    dataPass.masterMenu = this.inputData;
    dataPass.menu = this.headerTitle || this.widgetDesc || 'People in your Network';
    dataPass.widgetName = "PeopleInyourNetworkComponent";
    this.router.navigate(['suggestions'], { queryParams: dataPass })
  }

  onScrollDown() { }

  getNetworkSuggestion() {
    console.log('PeopleInyourNetworkComponent: getNetworkSuggestion called, inputData =', this.inputData, 'apiCalled =', this.apiCalled);

    // Prevent duplicate API calls
    if (this.apiCalled) {
      console.log('PeopleInyourNetworkComponent: API already called, skipping');
      return;
    }

    if (this.inputData && this.inputData != "") {
      this.apiCalled = true; // Mark as called
      this.util.startLoader();
      const userId = localStorage.getItem('userId');
      console.log('PeopleInyourNetworkComponent: Making API call for inputData =', this.inputData);

      if (this.inputData == "BUSINESS") {
        // Get businessId from URL query params first, fallback to localStorage
        const businessId = this.pathdata?.businessId || localStorage.getItem('businessId');
        console.log('PeopleInyourNetworkComponent: Using businessId:', businessId, '(from URL:', !!this.pathdata?.businessId, ')');

        this.auth.query("widget/user/network/active/" + userId + "?activityType=BUSINESS&activityEntityId=" + businessId + "&page=0&size=3")
          .subscribe((res) => {
            this.util.stopLoader();
            if (res && res != null && res.length != 0) {
              this.peopelData = res;
            } else {
              this.hide(true);
            }
          }, err => {
            this.util.stopLoader();
            this.hide(true);
          });

      } else if (this.inputData == "COMMUNITY") {
        // Get communityId from URL query params first, fallback to localStorage
        const communityId = this.pathdata?.communityId || localStorage.getItem('communityId');
        console.log('PeopleInyourNetworkComponent: Using communityId:', communityId, '(from URL:', !!this.pathdata?.communityId, ')');

        this.auth.query("widget/user/network/active/" + userId + "?activityType=COMMUNITY&activityEntityId=" + communityId + "&page=0&size=3")
          .subscribe((res) => {
            this.util.stopLoader();
            console.log('PeopleInyourNetworkComponent: API response:', res);
            if (res && res != null && res.length != 0) {
              this.peopelData = res;
            } else {
              // Hide widget on empty data (consistent with BUSINESS/HOME)
              this.hide(true);
            }
          }, err => {
            this.util.stopLoader();
            console.error('PeopleInyourNetworkComponent: API error:', err);
            // Hide widget on error (consistent with BUSINESS/HOME)
            this.hide(true);
          });

      } else if (this.inputData == "HOME") {
        this.auth.query("widget/user/network/active/" + userId + "?activityType=USER&activityEntityId=" + userId + "&page=0&size=3")
          .subscribe((res) => {
            this.util.stopLoader();
            if (res && res != null && res.length != 0) {
              this.peopelData = res;
            } else {
              this.hide(true);
            }
          }, err => {
            this.util.stopLoader();
            this.hide(true);
          });

      } else {
        this.util.stopLoader();
        this.hide(true);
      }
    }
  }

  routes(userId: string) {
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate(['personalProfile'], { queryParams: { "userId": userId } });
    });
  }

  connect(user: any) {
    this.util.startLoader();
    this.widget.connectService(user.userId).subscribe(conData => {
      this.util.stopLoader();
      if (conData.code === '00000') {
        this.widget.removeUserConnectionSuggesion(user['id']).subscribe(res => {
          if (res.code === '00000') {
            this.getNetworkSuggestion();
          }
        })
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: "Connection request",
          text: 'Connection request sent successfully',
          showConfirmButton: false,
          timer: 2000
        })
      } else if (conData.code === '88888') {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: "Connection request",
          text: 'Connection request failed. Please try again later.',
          showConfirmButton: false,
          timer: 3000
        })
      }
    });
  }

  hide(flag) {
    this.commonDatahide.widgetName = "PeopleInyourNetworkComponent";
    this.commonDatahide.hide = flag;
    // Support both EventEmitter (template binding) and callback function (NgComponentOutlet)
    if (typeof this.commonFunction === 'function') {
      this.commonFunction(this.commonDatahide);
    } else if (this.commonFunction?.emit) {
      this.commonFunction.emit(this.commonDatahide);
    }
  }


}
